import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { parseExtensionId } from '@atlassian/forge-ui/utils/parseExtensionId';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { useAdjustmentsContextActions } from '../../../../../../controllers/adjustments-context';
import { useUIModificationsConsentStatusForApp } from '../../../../../../controllers/adjustments-context/hooks/use-consent-status';
import { UIM_CONSENT_CONSENTED, UIM_CONSENT_REQUIRED, UIM_CONSENT_UNKNOWN } from '../../../../../../controllers/adjustments-context/types';
import { useViewType } from '../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { getConsentMessage } from '../../../../../../controllers/view-configuration';
export var useThreeLOPromptProps = function useThreeLOPromptProps(_ref) {
  var forgeExtension = _ref.forgeExtension;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasBeenTracked = _useState2[0],
    setHasBeenTracked = _useState2[1];
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useAdjustmentsContex = useAdjustmentsContextActions(),
    setUIModificationsConsentStatus = _useAdjustmentsContex.setUIModificationsConsentStatus;
  var _parseExtensionId = parseExtensionId(forgeExtension.id),
    appId = _parseExtensionId.appId;
  var viewType = useViewType();
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var currentUIModificationsConsentStatus = useUIModificationsConsentStatusForApp({
    appId: appId
  });
  var onConsentSuccess = useCallback(function () {
    setUIModificationsConsentStatus({
      appId: appId,
      status: UIM_CONSENT_CONSENTED
    });
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'cleared',
      actionSubject: 'jiraUiModificationsObligatoryConsent'
    });
  }, [appId, createAnalyticsEvent, setUIModificationsConsentStatus]);
  var onConsentInitialization = useCallback(function () {
    if (currentUIModificationsConsentStatus === UIM_CONSENT_UNKNOWN) {
      setUIModificationsConsentStatus({
        appId: appId,
        status: UIM_CONSENT_REQUIRED
      });
      if (!hasBeenTracked) {
        fireOperationalEvent(createAnalyticsEvent, {
          action: 'triggered',
          actionSubject: 'jiraUiModifications.obligatoryConsent',
          attributes: {
            viewType: viewType
          }
        });
        setHasBeenTracked(true);
      }
    }
  }, [appId, currentUIModificationsConsentStatus, setUIModificationsConsentStatus, hasBeenTracked, viewType, createAnalyticsEvent]);
  var consentMessage = useMemo(function () {
    return formatMessage(getConsentMessage(viewType), {
      appTitle: forgeExtension.properties.title
    });
  }, [formatMessage, forgeExtension.properties.title, viewType]);
  var threeLOPromptComponentPropsMethods = useMemo(function () {
    return {
      onConsentSuccess: onConsentSuccess,
      onConsentInitialization: onConsentInitialization,
      consentMessage: consentMessage
    };
  }, [onConsentSuccess, onConsentInitialization, consentMessage]);
  return threeLOPromptComponentPropsMethods;
};